import InfoModificationFormComponent from "../../components/post-signature/InfoModificationFormComponent";


export default function InfoModificationBloc() {

      return (
        <div className="">
          <InfoModificationFormComponent />
        </div>
      )
}